module.exports = __webpack_public_path__ + "img/Wagon_Back_Side_Left.ac285def.svg";